import { Animator } from "../Common/Animator";
import { Ceo } from "./Ceo";
import { Channels } from "./Channels";

export function Contact({ ceo, channels}) {
  return(
    <div id="contact">
      <section className="hero is-small is-primary">
        <div className="hero-body">
          <h2 className="subtitle is-2 bf-sub-title">Contáctanos</h2>
        </div>
      </section>
      <div style={{margin:"100px"}}>
        <Animator 
          component={ <Ceo ceo={ceo}/> }
        />
      </div>
      
      <Channels channels={channels}/>
    </div>
  );
}